import { PropsWithChildren } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { SelectWithFilter } from "../SelectWithFilter";
import { SelectOption, SelectWithFilterValue } from "../SelectWithFilter/types";
import { BaseField, BaseFieldProps } from "./BaseField";

interface SelectFieldProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends BaseFieldProps<TFieldValues, TName> {
  placeholder?: string;
  options: SelectOption[];
  isLoading?: boolean;
  onChange?: (selectedValue: SelectWithFilterValue) => void;
  defaultValue?: SelectWithFilterValue;
  returnValueKey?: keyof SelectOption;
  onFilterChange?: (currentFilter: string) => void;
  maxResults?: number;
  background?: string;
  isRelative?: boolean;
}

export function SelectField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
>({
  name,
  label,
  defaultValue,
  rules,
  placeholder,
  options,
  isLoading,
  onChange,
  form,
  readOnly,
  returnValueKey,
  onFilterChange,
  maxResults,
  background,
  isRelative,
  fieldClassName,
}: PropsWithChildren<SelectFieldProps<TFieldValues, TName>>) {
  return (
    <BaseField
      form={form}
      name={name}
      label={label}
      defaultValue={defaultValue}
      rules={rules}
      fieldClassName={`select-field ${fieldClassName} `}
      render={({ field }) => (
        <SelectWithFilter
          selectedValue={field.value}
          options={options}
          isLoading={isLoading}
          onFilterChange={onFilterChange}
          onChange={(newValue: SelectWithFilterValue) => {
            field.onChange(newValue);
            onChange?.(newValue);
          }}
          placeholder={placeholder}
          maxResults={maxResults}
          returnValueKey={returnValueKey}
          readOnly={readOnly}
          background={background}
          isRelative={isRelative}
        />
      )}
    />
  );
}

SelectField.defaultProps = {
  defaultValue: "",
};
